import { render, staticRenderFns } from "./rb.pass.vue?vue&type=template&id=1d5acd38&scoped=true"
import script from "./rb.pass.vue?vue&type=script&lang=js"
export * from "./rb.pass.vue?vue&type=script&lang=js"
import style0 from "./rb.pass.vue?vue&type=style&index=0&id=1d5acd38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5acd38",
  null
  
)

export default component.exports